<section class="header-section">
    <h2>Nueva regla</h2>
    <button mat-icon-button (click)="clickCloseDialog()">
        <mat-icon>close</mat-icon>
    </button>
</section>
<section class="main-body">
    <form 
    [formGroup]="registerForm"
    (ngSubmit)="submit()">
        <div class="form-inputs-section">
            <mat-form-field class="item1">
                <mat-label>Nombre</mat-label>
                <input formControlName="name" matInput>
            </mat-form-field>

            <mat-form-field>
                <mat-label>N° Firmas</mat-label>
                <input type="number" formControlName="requiredApproval" matInput/>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Prioridad</mat-label>
                <input type="number" formControlName="priority" matInput>
            </mat-form-field>

            <mat-form-field class="item1">
                <mat-label>Descripción</mat-label>
                <textarea matInput formControlName="description" cdkTextAreaAutosize
                cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5">
                </textarea>    
            </mat-form-field>
            <mat-form-field>
                <mat-label>Roles</mat-label>
                <mat-select formControlName="roles" [multiple]="true">
                    @for(role of rolesToAssign$ | async; track role) {
                        <mat-option [value]="role.roleId">
                            {{role.name}}
                        </mat-option>
                    }
                </mat-select>   
            </mat-form-field>
        </div>

        <div>
            <section class="condition-header-section ">
                <h3>Condiciones</h3>
                <button type="button" mat-mini-fab (click)="addCondition()">
                    <mat-icon>add</mat-icon>
                </button>
            </section>
            <div class="conditions-section">
                @if(conditions.length  == 0) {
                    <div style="text-align: center;">
                        <span style="font-weight: 600;">Sin condiciones registradas</span>
                    </div>
                }
                <ng-container formArrayName="conditions">
                    <div style="margin:0.5rem" *ngFor="let condition of conditions.controls; let i = index">
                        <mat-card>
                            <div class="condition-input-header">
                                <button type="button" mat-icon-button color="warn" (click)="removeCondition(i)">
                                    <mat-icon>remove</mat-icon>
                                </button>
                            </div>
                            <div class="grid-condition-input" [formGroupName]="i">
                                <app-minute-approval-condition-form-group
                                [parameters]="approvalParameters"
                                [group]="getConditionGroup(i)">
                                </app-minute-approval-condition-form-group>
                            </div>    
                        </mat-card>
                    </div>    
                </ng-container>
    
            </div>
        </div>
        <div class="action-section">
            <button [disabled]="registerForm.invalid" type="submit" mat-raised-button color="primary">
                Registrar
            </button>
        </div>
    </form>
</section>